export const messages = {
    required: 'Ce champ est obligatoire',
    email: 'Saisir une adresse email valide',
    tooLong: 'La saisie est trop longue',
    tooShort: 'La saisie est trop courte',
    invalid: 'Format incorrect'
}